// Auth Store - Zustand State Management
import { create } from 'zustand';
import { IUser } from '../interfaces/IUser';

interface AuthState {
  user: IUser | null;
  token: string | null;
  isLoading: boolean;
  error: string | null;
  setUser: (user: IUser) => void;
  setToken: (token: string) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: (() => {
    try {
      const stored = localStorage.getItem('authUser');
      return stored ? (JSON.parse(stored) as IUser) : null;
    } catch {
      return null;
    }
  })(),
  token: localStorage.getItem('authToken'),
  isLoading: false,
  error: null,

  setUser: (user: IUser) => {
    localStorage.setItem('authUser', JSON.stringify(user));
    set({ user });
  },
  setToken: (token: string) => set({ token }),
  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    set({ user: null, token: null });
  },
  setLoading: (loading: boolean) => set({ isLoading: loading }),
  setError: (error: string | null) => set({ error }),
}));
